(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bzk-growth-events"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.bzkGrowthEventsBound) return;
    window.bzkGrowthEventsBound = true;

    const placements = ['product', 'mobile_sticky', 'intro', 'closing'];

    function analyticsAllowed() {
      try {
        return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
      } catch {
        return false;
      }
    }

    function emit(event, channel, element) {
      if (!analyticsAllowed()) return;
      const placement = element?.getAttribute('data-bzk-growth-placement');
      window.dataLayer = window.dataLayer || [];
      const payload = {
        event,
        channel,
        page_path: window.location.pathname,
        placement: placements.includes(placement) ? placement : 'other',
      };
      window.dataLayer.push(payload);

      const ga4Event = event === 'bzk_contact_click' && channel === 'whatsapp'
        ? 'bzk_whatsapp_click'
        : event;
      if (!['bzk_quote_click', 'bzk_whatsapp_click', 'bzk_contact_submitted', 'bzk_reserve_click'].includes(ga4Event)) return;
      if (typeof window.gtag !== 'function') return;

      // Reuse the existing configured Google tag; never create another config.
      window.gtag('event', ga4Event, {
        send_to: 'G-B70N0LLWXD',
        channel: payload.channel,
        page_path: payload.page_path,
        placement: payload.placement,
        page_location: window.location.origin + payload.page_path,
        page_referrer: '',
        page_title: 'Bizak & Co. sourcing enquiry',
      });
    }

    document.addEventListener('click', (event) => {
      const element = event.target?.closest?.('[data-bzk-growth-action], a[href]');
      if (!element) return;

      const action = element.getAttribute('data-bzk-growth-action');
      if (action === 'product_quote' || action === 'article_quote' || action === 'collection_quote') {
        emit('bzk_quote_click', 'contact_form', element);
        return;
      }
      if (action === 'offer_open') {
        emit('bzk_quote_click', 'offer_form', element);
        return;
      }
      if (action === 'reserve_open') {
        emit('bzk_reserve_click', 'deposit', element);
        return;
      }
      if (action === 'whatsapp') {
        emit('bzk_contact_click', 'whatsapp', element);
        return;
      }

      const href = element.getAttribute('href');
      if (!href) return;
      try {
        const url = new URL(href, window.location.origin);
        if (url.protocol === 'tel:') {
          emit('bzk_contact_click', 'phone', element);
        } else if (
          url.protocol === 'whatsapp:' ||
          (['https:', 'http:'].includes(url.protocol) &&
            ['wa.me', 'api.whatsapp.com', 'web.whatsapp.com'].includes(url.hostname))
        ) {
          emit('bzk_contact_click', 'whatsapp', element);
        }
      } catch {}
    }, true);

    let serverSuccessReported = false;

    function reportServerSuccess() {
      if (serverSuccessReported || document.readyState === 'loading' || !analyticsAllowed()) return;
      const success = document.querySelector('[data-bzk-quote-success]');
      if (success) {
        serverSuccessReported = true;
        emit('bzk_contact_submitted', 'contact_form', success);
      }
    }

    if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (!error) reportServerSuccess();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', reportServerSuccess, { once: true });
    } else {
      reportServerSuccess();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["contact-form"] && !Shopify.designMode) return;
  try {
    function initializeSourcingContacts(root = document) {
    root.querySelectorAll('[data-bzk-sourcing-contact], [data-bzk-sell-contact]').forEach((container) => {
      if (container.dataset.bzkContactReady) return;
      container.dataset.bzkContactReady = 'true';
      const form = container.querySelector('form');
      const source = form.querySelector('[data-bzk-quote-source]');
      const validSourcePath = (value) => {
        if (value && value.startsWith(window.location.origin + '/')) value = value.slice(window.location.origin.length);
        if (!value || !value.startsWith('/') || value.startsWith('//') || /[\\?#\s\u0000-\u001f]/.test(value) || /%(?:2f|5c|3f|23|0[0-9a-f]|1[0-9a-f]|7f)/i.test(value)) return '';
        try {
          const url = new URL(value, window.location.origin);
          return url.origin === window.location.origin && !url.search && !url.hash && url.pathname === value ? url.href : '';
        } catch {
          return '';
        }
      };
      source.value = validSourcePath(source.value);
      const purpose = form.querySelector('[data-bzk-inquiry-type]');
      const isSell = container.hasAttribute('data-bzk-sell-contact');
      const guidance = {
        'Consignment inquiry': 'Describe the reference, condition, box and papers, service history, and when you hope to sell. We will discuss suitability, net proceeds and written consignment terms before handover. No sourcing deposit is needed for this inquiry.',
        'Service and repair inquiry': 'Describe the fault, when it began, any impact or water exposure, and the last service if known. Include your Bizak invoice number for a possible warranty claim. We will confirm the assessment process and any charges before work is authorized.',
        'Customization inquiry': 'Describe the changes you want and whether the watch is already yours or needs to be sourced. Tell us if factory-original parts and preserving the existing finish are essential. We will discuss feasibility, parts, price and warranty implications before work is authorized.',
        'Authentication and appraisal inquiry': 'Tell us the reference and why you need the assessment. For an insurance appraisal, include the insurer’s document requirements, without policy or personal ID numbers. A replacement valuation is different from an offer to buy your watch; fees and deliverables are confirmed before you proceed.',
        'Payment inquiry': 'Tell us which watch and payment method you are considering, plus your delivery country and postal code. We will confirm available methods and the final invoice. Please check financing eligibility with us before paying a sourcing deposit.',
        'Order support': 'Include your invoice or order number and describe what you need. For delivery or condition issues, keep the packaging and photographs. No new sourcing deposit is needed to request help with an existing order.'
      };
      const updateIntro = () => {
        form.querySelectorAll('[data-bzk-for]').forEach((group) => {
          const active = group.dataset.bzkFor.split('|').includes(purpose.value);
          group.hidden = !active;
          group.querySelectorAll('input, select, textarea').forEach((input) => { input.disabled = !active; });
        });
        if (isSell) return;
        const sourcing = purpose.value === 'General inquiry' || purpose.value === 'Sourcing inquiry';
        form.querySelector('[data-bzk-sourcing-intro]').hidden = !sourcing;
        form.querySelector('[data-bzk-service-intro]').hidden = sourcing;
        form.querySelector('[data-bzk-service-guidance]').textContent = guidance[purpose.value] || '';
      };
      purpose.addEventListener('change', updateIntro);
      updateIntro();
      if (form.querySelector('[data-bzk-contact-errors], .contact-form__success')) return;
      const params = new URLSearchParams(window.location.search);
      const intent = params.get('intent');
      const prefill = (selector, parameter) => {
        const input = form.querySelector(selector);
        if (!input.value) input.value = (params.get(parameter) || '').trim().slice(0, input.maxLength);
      };
      if (isSell) {
        if (intent !== 'sell' && intent !== 'trade') return;
        purpose.value = intent === 'trade' ? 'Trade a watch' : 'Sell a watch';
        prefill(intent === 'trade' ? '[data-bzk-trade-target]' : '[data-bzk-owned-watch]', 'subject');
        prefill(intent === 'trade' ? '[data-bzk-trade-reference]' : '[data-bzk-owned-reference]', 'reference');
        updateIntro();
      } else {
        if (intent === 'sourcing') purpose.value = 'Sourcing inquiry';
        else if (intent === 'service') {
          const services = new Map([
            ['consignment', 'Consignment inquiry'],
            ['repair', 'Service and repair inquiry'],
            ['customization', 'Customization inquiry'],
            ['authentication', 'Authentication and appraisal inquiry'],
            ['payment', 'Payment inquiry'],
            ['order', 'Order support']
          ]);
          purpose.value = services.get(params.get('service')) || 'General inquiry';
        } else return;
        prefill('[data-bzk-quote-subject]', 'subject');
        prefill('[data-bzk-quote-reference]', 'reference');
        updateIntro();
      }
      if (!source.value) source.value = validSourcePath(params.get('source') || '');
    });
  }
  initializeSourcingContacts();
  document.addEventListener('shopify:section:load', (event) => initializeSourcingContacts(event.target));
  } catch(e) { console.error(e); }
})();

})();
